import { Component, Input, OnChanges } from "@angular/core";
import { ProductService } from "src/app/services/api/product.service";
import { Router } from "@angular/router";
import { BsModalService, BsModalRef, ModalOptions } from "ngx-bootstrap/modal";
import { ArtworkComponent } from "src/app/components/modals/artwork/artwork.component";
import { InfoComponent } from "src/app/components/modals/info/info.component";
import { SessionService } from "src/app/services/session.service";
import { CartService } from "src/app/services/api/cart.service";
import { LangService } from "src/app/services/lang/lang.service";
import { Sizing } from "src/app/lib/sizing";
import { DecimalPipe } from "@angular/common";
import { DebounceService } from "src/app/services/debounce.service";
import { environment } from "src/environments/environment";
import { FbpixelService } from "src/app/services/api/fbpixel.service";

@Component({
	selector: "app-product-options",
	templateUrl: "./product-options.component.html",
	styleUrls: ["./product-options.component.scss"],
})
export class ProductOptionsComponent implements OnChanges {

	@Input() product: any = null;
	env:any = environment;

	/**
	 * the cofigurabe product childs
	 */
	childrens: any = null;

	/**
	 * the selected cofigurabe product child
	 */
	selectedChild: any = null;
	selectedQty: any = null;
	selectedQtyPrice: any = null;
	qtyInfo:any = null;
	productChilds: any = {};
	selectedCuttingType:any = null;

	discount:number = 0;
	priceInfo: any = null;

	/**
	 * the selected option to be add to cart
	 */
	activeOpt: any = "";
	activeFW: any = {
		shape: "",
		size: "",
		quantity: "",
		adhesive: ""
	};
	customInputSelected: any = "no";

	customSize: any = null;
	sizes: any = null;
	doNotMerge: any = null;
	cuttingType:any = null;
	cuttingTypeInputSelected:any = null;


	adhesive: any = null;
	selectedAdhesive: any = null;
	adhesiveInputSelected: any = null;
	adhesiveOptions: any = null;

	maxWidth: any = 0;
	maxHeight: any = 0;
	sizing: any = null;

	activeShape: any = {
		circle: "",
		rectangle: "",
		square: "",
		custom: "",
	};

	sku: any = {
		circle: "",
		rectangle: "",
		square: "",
		customshape: "",
	};

	itemQtyArray: any = [10,50,100,200,300,500,1000,2000,3000,4000,5000,10000];
	itemQtyPrice: any = [];
	itemQtyPriceLoading:boolean = false;
	matrixPrice: any = {};

	/* the selected size if the user choose custom size */
	sizeWidth: any = null;
	sizeHeight: any = null;
	selectedSizeIdentifier: any = "";

	/* custom price from entrelabel magento config */
	customPrice: any = null;
	selectedCustomPrice: any = null;
	currentPrice: any = 0;
	priceAddFivePercent: boolean = false;
	totals: any = null;

	modalRef: BsModalRef;

	// generateQtyPricingDebounce: any = null;

	extraStickyAdhesiveNote: any = null;

	customOptionPrice:any = [];

	/**
	 * custom option pricing types
	 */
	pricingType = {
		/** add the price for each item qty eg: (custom_option_price + item_price) * qty   */
		fixed: 'fixed', 
		/** add the price in total of item's qty eg: (custom_option_price + (item_price * qty)) + item_price * qty */
		item_total_plus_option_price: 'item_total_plus_option_price'
	}

	qtyNote:string = '';

	
	asIsPricingItems = [];
	useStickerRollPricing = "";


	constructor(
		public productService: ProductService,
		public router: Router,
		public modalService: BsModalService,
		public cartService: CartService,
		public lang: LangService,
		public sessionService: SessionService,
		public debounce: DebounceService,
		private decimalPipe: DecimalPipe,
		public fbpixel: FbpixelService
	) {}

	ngOnChanges(changes) {
		this.sizing = Sizing;
		this.maxWidth = Sizing.maxWidth;
		this.maxHeight = Sizing.maxHeight;
		this.asIsPricingItems = [];

		if (this.product) {

			this.qtyNote = 'Quantity is per piece of sticker label.';
			if(this.product.sku == 'custom-cards'){
				this.qtyNote = 'Quantity is per piece of card label.';
			}

			this.useStickerRollPricing = this.productService.getCustomAttr('use_sicker_roll_pricing', this.product) + "";
			if(this.useStickerRollPricing == "1"){
				let entrelabelPriceRange = JSON.parse(this.productService.getCustomAttr('entrelabel_price_range', this.product));
				
				this.maxWidth = entrelabelPriceRange.max_size.width
				this.maxHeight = entrelabelPriceRange.max_size.height == "*" ? null : entrelabelPriceRange.max_size.height;
				this.asIsPricingItems.push(this.product.sku);
			}

			this.getChildren();
			this.setCustomOption();

			this.product.custom_attributes.forEach(attr => {
				if(attr.attribute_code == 'extra_sticky_adhesive_note'){
					this.extraStickyAdhesiveNote = attr.value;
				}
			});
		}
	}

	decimalPipe_transform(){
		if (this.sizeHeight != ""){
			// this.sizeHeight = parseFloat(this.decimalPipe.transform(this.sizeHeight, "2.1-1"));
			this.sizeHeight = parseFloat(this.sizeHeight);
		}
		if(this.sizeWidth != ""){
			// this.sizeWidth = parseFloat(this.decimalPipe.transform(this.sizeWidth, "2.1-1"));
			this.sizeWidth = parseFloat(this.sizeWidth);
		}
	}

	setCustomOption() {
		let opt = this.product.options;

		this.sizes = null;
		this.customSize = null;
		this.doNotMerge = null;
		this.cuttingType = null;

		this.adhesive = null;
		this.adhesiveOptions = null;
		this.adhesiveInputSelected = null;
		this.cuttingTypeInputSelected = null;
		this.selectedAdhesive = null;
		this.selectedCuttingType = null;

		this.setActiveOpt('size', false);

		opt.forEach((val) => {
			if (val.title == "sizes") {
				this.sizes = val;
			}
			if (val.title == "custom size") {
				this.customSize = val;
			}
			if (val.title == "do not merge") {
				this.doNotMerge = val;
			}
			if (val.title == "cutting type") {
				this.cuttingType = val;
			}

			/** un comment the below condition if adhesive option is needed */
			// if (val.title == "adhesive") {
			// 	this.adhesive = val;
			// }
			// if (val.title == "adhesive_options") {
			// 	this.adhesiveOptions = val;
			// }
		});

		this.productService.getCustomPrice().then((customPrice) => {
			let cp: any = customPrice;
			if (cp) {
				this.customPrice = customPrice[0];
			}
		});
	}

	/**
	 * get all children from magento database api
	 */
	getChildren() {
		let url = "/rest/entrelable/V1/configurable-products/" + this.product.sku + "/children";
		this.productService.get(url).subscribe(
			(result) => {
				this.childrens = result;
				this.getChildrenHelper();
			},
			(error) => this.requestErrorHandler(error)
		);
	}
	getChildrenHelper() {
		this.childrens.forEach((val) => {
			let name = val.name.toLowerCase();
			name = name.replace(" ", "");
			this.sku[name] = val.sku;
		});
		this.setSelectedChild(this.sku.customshape, "custom");
	}

	/**
	 * process the error toast if the product doesn't exists
	 */
	requestErrorHandler(error) {
		this.productService.errorHandler(error);
		this.router.navigate(["/catalog"]);
	}

	/**
	 * set what is active option
	 */
	setActiveOpt(opt: any = "", collapse:boolean = true) {
		this.activeFW = {
			shape: "",
			size: "",
			quantity: "",
			adhesive: ""
		};

		if (this.activeOpt == opt) {
			if(collapse){
				this.activeOpt = "";
			} else {
				this.activeOpt = opt;
				this.activeFW[opt] = "fw-800";
			}
		} else {
			this.activeOpt = opt;
			this.activeFW[opt] = "fw-800";
		}

		if(opt == 'quantity'){
			if(this.selectedSizeIdentifier != 'custom size'){
				this.sizes.values.forEach((s:any) => {
					if(s.option_type_id == this.selectedSizeIdentifier){
						this.generateQtyPricing(s.title);
					}
				});
			}
			else {
				this.generateQtyPricing();
			}
		}
	}

	resetSelected(){
		this.itemQtyPrice = [];
		this.itemQtyPriceLoading = false;
		this.selectedSizeIdentifier = "";
		this.sizeWidth = "";
		this.sizeHeight = "";
		this.selectedQty = null;
		this.totals = null;
		this.selectedCuttingType = null;
		this.adhesiveInputSelected = null;
		this.cuttingTypeInputSelected = null;
		this.setActiveOpt('size');
	}

	/**
	 * set which product child is selected
	 */
	setSelectedChild(childSku: string = "", selected: string = "") {
		this.selectedChild = null;
		this.itemQtyPrice = [];
		this.selectedSizeIdentifier = "";
		this.sizeWidth = "";
		this.sizeHeight = "";
		this.selectedQty = null;
		this.totals = null;

		this.activeShape = {
			circle: "",
			rectangle: "",
			square: "",
			custom: "",
		};
    	this.activeShape[selected] = " active";

		if (selected == "custom") {
			this.priceAddFivePercent = true;
		} else {
			this.priceAddFivePercent = false;
		}

		let url = "/rest/entrelable/V1/products/" + childSku;
		this.productService.get(url).subscribe(
			(result) => {
				this.selectedChild = result;
				this.productChilds[result.sku] = result;
				this.activeOpt = "size";
			},
			(error) => this.productService.errorHandler(error)
		);
	}

	/**
	 * open the modal for uploading an artwork
	 */
	uploadArtWork() {
		let config: ModalOptions = {
			backdrop: "static",
			keyboard: false,
			animated: true,
			ignoreBackdropClick: true,
			initialState: {},
		};

		let w = parseFloat(this.sizeWidth);
		let h = parseFloat(this.sizeHeight);

		if (!this.selectedChild) {
			this.productService.toastService.add("Please select a shape", "danger");
		}
		else if (!w || !h) {
			this.productService.toastService.add("Please select size or enter width and height", "danger");
			this.setActiveOpt('size', false);
		} 
		else if(!this.selectedQty){
			this.productService.toastService.add("Please select qty", "danger");
			this.setActiveOpt('quantity', false);
		}
		// else if(this.adhesive && !this.selectedAdhesive){
		// 	this.productService.toastService.add("Please select sticker adhesive", "danger");
		// 	this.setActiveOpt('adhesive', false);
		// } 
		// else if(this.adhesive && !this.selectedAdhesive){
		// 	this.productService.toastService.add("Please select sticker adhesive", "danger");
		// 	this.setActiveOpt('adhesive', false);
		// } 
		else if (this.cuttingType && !this.selectedCuttingType) {
			this.productService.toastService.add("Please select cutting type", "danger");
			this.setActiveOpt('quantity', false);
		} 
		else if (this.selectedQty < parseInt(this.itemQtyPrice[0].from)) {
			this.productService.toastService.add("We accept order minimum qty of "+this.itemQtyPrice[0].from+" pcs", "danger");
			this.setActiveOpt('quantity', false);
		} 
		else if (!this.selectedSizeIdentifier) {
			this.productService.toastService.add("Please select size or enter width and height 2", "danger");
			this.setActiveOpt('size', false);
		} 
		else {
			if (!w || !h) {
				this.productService.toastService.add("Please enter a valid custom size", "danger");
			} 
			else if (w > this.maxWidth) {
				this.productService.toastService.add("The max width is " + this.maxWidth + " " + this.sizing.unit, "danger");
			} 
			else if (this.maxHeight && h > this.maxHeight) {
				this.productService.toastService.add("The max height " + this.maxHeight + " " + this.sizing.unit, "danger");
			} 
			else {
				this.fbPixel();
				
				config.initialState = {
					product: this.product,
					selectedQty: this.selectedQty,
					selectedQtyPrice: this.selectedQtyPrice,
					selectedChild: this.selectedChild,
					customOption: this.setCustomOptionValue(),
					awupload: "addtocart"
				};

				this.modalRef = this.modalService.show(ArtworkComponent, config);
				this.modalRef.setClass("artwork-modal modal-dialog-centered");
				this.modalRef.content.onClose = (myData) => {
					this.modalRef.hide();

					this.fbPixel('AddToCart');
					if(typeof myData['item_id'] != 'undefined'){
						setTimeout(() => {
							this.resetSelected();
						}, 500);
					}
				};
			}
		}
	}

	setCustomOptionValue() {
		let d = new Date();
		let customOption: any = [
			{
				option_id: this.customSize.option_id,
				option_value: this.sizeWidth + " x " + this.sizeHeight,
			},
			{
				option_id: this.doNotMerge.option_id,
				option_value: d.getTime(),
			},
		];

		if(this.adhesive && this.selectedAdhesive){
			customOption.push({
				option_id: this.adhesive.option_id,
				option_value: this.selectedAdhesive.title
			});
		}

		if(this.selectedCuttingType){
			customOption.push({
				option_id: this.cuttingType.option_id,
				option_value: this.selectedCuttingType.option_type_id
			});
		}

		return customOption;
	}

	/**
	 * generate the qty price list including the calculated
	 * price per each qty
	 */
	generateQtyPricing(size: any = null) {
		this.itemQtyPrice = [];
		this.selectedQty = 0;

		if (size) {
			size = size.replace(" cm", "");
			size = size.replace(" cm", "");
			size = size.split(" x ");
			this.sizeWidth = parseFloat(size[0]);
			this.sizeHeight = parseFloat(size[1]);
		}

		this.decimalPipe_transform();
		let sqrSize = this.sizeWidth * this.sizeHeight;

		if(sqrSize){
			this.useStickerRollPricing = this.productService.getCustomAttr('use_sicker_roll_pricing', this.product) + "";

			let entrelabelPriceRange = null;
			if(this.useStickerRollPricing  == "1"){
				entrelabelPriceRange = JSON.parse(this.productService.getCustomAttr('entrelabel_price_range', this.product));
			}

			if (entrelabelPriceRange) {
				if(entrelabelPriceRange && this.sizeWidth > entrelabelPriceRange.max_size.width){
					this.itemQtyPriceLoading = false;
					this.productService.toastService.add("Max width: " + entrelabelPriceRange.max_size.width + " " + entrelabelPriceRange.max_size.unit, "danger");
					return false;
				}
			}
			else if (this.sizeWidth > this.maxWidth || this.sizeHeight > this.maxHeight) {
				this.itemQtyPriceLoading = false;
				this.productService.toastService.add("Max size: " + this.maxWidth + " " + this.sizing.unit + " x " + this.maxHeight + " " + this.sizing.unit, "danger");
				return false;
			}
			else if(this.sizeWidth < 1 && this.sizeHeight < 1){
				this.itemQtyPriceLoading = false;
				this.productService.toastService.add("Either width or height should be at least 1 cm", "danger");
				return false;
			}
			
			if (this.sizeWidth && this.sizeHeight) {
				if (this.selectedChild) {
					this.itemQtyPriceLoading = true;
					let url = "/rest/entrelable/V1/lns-entrelabel/pricing/";
					url += this.sizeWidth + "/" + this.sizeHeight + "/" + this.product.sku + "/" + this.selectedChild.name;
					this.cartService.get(url).subscribe(
						(pricing) => {
							console.log('pricing pricing', pricing, this.asIsPricingItems);
							setTimeout(() => {
								this.matrixPrice[this.product.sku + this.selectedChild.name] = pricing;
								this.itemQtyPrice = pricing;
								this.itemQtyPriceLoading = false;

								if( !this.asIsPricingItems.includes(this.product.sku) ){
									this.setPricingDiscount();
								}
							}, 1000);
						},
						(error) => {
							this.cartService.errorHandler(error);
						}
					);
				}
			}
		}
	}

	setPricingDiscount(){
		this.itemQtyPrice.forEach(qtyPrice => {
			let qty = parseInt(qtyPrice.from);
			let discountRange = this.customPrice.discount.find(
				i => (
					(qty >= i.from && qty <= i.to) || (qty >= i.from && i.to == '*')
				)	
			);

			qtyPrice.discounted_price = 0;

			if(discountRange){
				let discountPercent = parseFloat(discountRange.discount);
				if(discountPercent > 0){
					let price = qtyPrice.price;
		
					let priceDiscount = price - this.cartService.formatNumber(price - (price * (discountPercent / 100)), 2);
					let discountedPriceEach = price - priceDiscount;

					qtyPrice.discounted_price = discountedPriceEach;
				}
			}
		});

		console.log('itemQtyPrice itemQtyPrice itemQtyPrice', this.itemQtyPrice);
	}

	setAdhesive(value:any = null){
		if(value){
			this.selectedAdhesive = value;
			this.setActiveOpt("quantity", false);
		}
	}

	addPricingBreakdown(title:any, price:any, pricing_type:string = this.pricingType.fixed){
		let isAdded = false;
		this.customOptionPrice.forEach((val:any, key:any) => {
			if(val.title == title){
				this.customOptionPrice[key]['price'] = price;
				isAdded = true;
			}
		});
		if(!isAdded){
			this.customOptionPrice.push({
				title: title,
				price: price,
				total: 0,
				pricing_type: pricing_type
			});
		}
	}

	removePricingBreakdown(title){
		this.customOptionPrice.forEach((val, key) => {
			if(val.title == title){
				this.customOptionPrice.splice(key,1);
			}
		});
	}

	setQty(qty: any = null, customInput: any = "no", qtyInfo:any=null) {
		this.customInputSelected = customInput;
		this.selectedQty = parseInt(qty);
		this.selectedQtyPrice = 0;
		if(customInput == 'yes'){
			this.selectedQtyPrice = this.getCustomQtyPrice;
		}
		else if(qtyInfo){
			this.selectedQtyPrice = qtyInfo.price;
		}

		if( !this.asIsPricingItems.includes(this.product.sku) ){
			this.calcutaleDiscount();
		}


		this.addPricingBreakdown('subtotal', this.selectedQtyPrice, this.pricingType.fixed);
	}

	setCuttingType(value:any){
		this.selectedCuttingType = value;

		this.selectedQty = null;
		this.removePricingBreakdown('qty');
		this.removePricingBreakdown('Die Cut Fee');
		this.removePricingBreakdown('Sticker Pad Fee');

		if(this.selectedCuttingType.price){

			let pricingType = this.pricingType.fixed;
			if(this.selectedCuttingType.title == 'Sticker Pad'){
				pricingType = this.pricingType.item_total_plus_option_price;
			}
			this.addPricingBreakdown(this.selectedCuttingType.title + ' Fee', this.selectedCuttingType.price, pricingType);
		}
	}

	get getCustomQtyInputPriceDiscount() {
		let discountedPriceEach = 0;

		if( !this.asIsPricingItems.includes(this.product.sku) ){
			let qty = parseInt(this.selectedQty);
			let discountRange = this.customPrice.discount.find(
				i => (
					(qty >= i.from && qty <= i.to) || (qty >= i.from && i.to == '*')
				)	
			);

			if(discountRange){
				let discountPercent = parseFloat(discountRange.discount);
				let price = parseFloat(this.selectedQtyPrice);
				if(discountPercent > 0){
					let priceDiscount = price - this.cartService.formatNumber(price - (price * (discountPercent / 100)), 2);
					discountedPriceEach = price - priceDiscount;
				}
			}
		}

		return discountedPriceEach;
	}

	get getCustomQtyPricing(){
		let price: any = null;
		this.itemQtyPrice.forEach((pricing) => {
			let from = parseInt(pricing.from);
			if (pricing.to == "*") {
				if (this.selectedQty >= from) {
					price = pricing;
				}
			} else {
				let to = parseInt(pricing.to);
				if (this.selectedQty >= from && this.selectedQty <= to) {
					price = pricing;
				}
			}
		});
		return price;
	}

	get getCustomQtyPrice() {
		let price = this.getCustomQtyPricing ? this.getCustomQtyPricing.price : 0;
		return price;
	}

	get total() {
		let customOptionPrice: any = 0;
		this.customOptionPrice.forEach((val, key) => {

			this.customOptionPrice[key].total = val.price;
			if(val.pricing_type == this.pricingType.fixed && this.selectedQty){
				this.customOptionPrice[key].total = val.price * this.selectedQty;
			}
			else if(val.pricing_type == this.pricingType.item_total_plus_option_price && this.selectedQty){
				this.customOptionPrice[key].total = this.customOptionPrice[key].total + (this.getCustomQtyPrice * this.selectedQty);
			}

			customOptionPrice += this.customOptionPrice[key].total;

		});
		return customOptionPrice + '';
	}

	get discountedTotal(){
		let total = parseFloat(this.total) - this.discount;
		return total + '';
	}

	setCustomQtyInit(event) {
		this.customInputSelected = "yes";
		this.setQty(event.target.value, "yes");
	}

	isNumberKey(evt: any) {
		let charCode = evt.which ? evt.which : evt.keyCode;
		if (
			charCode == 8 ||
			charCode == 9 ||
			charCode == 110 ||
			charCode == 190 ||
			(charCode >= 96 && charCode <= 105) ||
			(charCode >= 48 && charCode <= 57) ||
			(charCode >= 37 && charCode <= 40)
		) {
			return true;
		} else {
			return false;
		}
	}

	openInfoModal() {
		let config: ModalOptions = {
			backdrop: "static",
			keyboard: false,
			animated: true,
			ignoreBackdropClick: true,
			initialState: {
				blockId: 28,
			},
		};

		this.modalRef = this.modalService.show(InfoComponent, config);
		this.modalRef.setClass("info-modal product-info modal-dialog-centered");
		this.modalRef.content.onClose = (myData) => {
			this.modalRef.hide();
		};
	}


	/**
	 * the pixel here is only for ViewContent event
	 * @param event 
	 */
	fbPixel(event = 'ViewContent'){

		let price = 0;
		try {
			price = (parseFloat(this.total) / this.selectedQty);
		} catch (error) {
			price = 0;
		}

		if(price > 0){
			let fbqData = {
				content_name: this.product.sku,
				content_category: 'Default',
				content_ids: [this.product.id],
				content_type: 'product',
				value: price,
				currency: 'PHP'
			}
			this.fbpixel.fbq('track', event, JSON.parse(JSON.stringify(fbqData)));
	
			let ttqData = {  
				contents: [
					{
						content_id: this.product.id + '',
						content_name: this.product.sku,
						quantity: this.selectedQty,
						price: price,
					}
				],
				content_type: 'product',
				value: this.total,
				currency: 'PHP',  
			}
			this.fbpixel.ttq(event, JSON.parse(JSON.stringify(ttqData)));
		}
	}

	calcutaleDiscount(){
		let discountResult = 0;
		
		this.priceInfo = null;
		if(this.customPrice){
			if(this.selectedQty){
				let price = parseFloat(this.selectedQtyPrice);
				let qty = parseInt(this.selectedQty);

				let discountRange = this.customPrice.discount.find(
					i => (
						(qty >= i.from && qty <= i.to) || (qty >= i.from && i.to == '*')
					)	
				);

				if(discountRange){
					let cuttingType = this.selectedCuttingType ? this.selectedCuttingType.title : '';
					let cuttingTypePrice = this.selectedCuttingType ? this.selectedCuttingType.price : '';
					let discountPercent = parseFloat(discountRange.discount);

					let optPrice = 0;
					if(cuttingType == 'Die Cut'){
						optPrice += cuttingTypePrice;
					}
					// price += optPrice;
					price = this.cartService.formatNumber(price + optPrice, 2);

					

					let discountedPriceEach = 0;
					let strickerPadFee = 0;
					let strickerPadFeeOrig = 0;
					let discounted = null;

					if(discountPercent > 0){
						let priceDiscount = price - this.cartService.formatNumber(price - (price * (discountPercent / 100)), 2);
						// let discountAmount = this.cartService.formatNumber(priceDiscount * qty, 2);
						discountedPriceEach = price - priceDiscount;

						if(cuttingType == 'Sticker Pad'){
							strickerPadFeeOrig = this.cartService.formatNumber((price * qty) + cuttingTypePrice, 2);
							if(discountPercent > 0){
								strickerPadFee = this.cartService.formatNumber((discountedPriceEach * qty) + cuttingTypePrice, 2);
							}
						}

						discounted = {
							'price': discountedPriceEach,
							'total_item_price': discountedPriceEach * qty,
							'stricker_pad_fee': strickerPadFee,
							'total': (discountedPriceEach * qty) + strickerPadFee
						}
					}

					let result = {
						'original': {
							'price': price,
							'total_item_price': price * qty,
							'stricker_pad_fee': strickerPadFeeOrig,
							'total': (price * qty) + strickerPadFeeOrig
						},
						'dicounted': discounted
					}

					if(result.dicounted){
						discountResult = result.original.total - result.dicounted.total;
					}
					
					this.priceInfo = result;
				}
			}
		}

		this.discount = discountResult;
	}
}
